import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const PropsTable = makeShortcode("PropsTable");
const PropsTableRow = makeShortcode("PropsTableRow");
const PropsTableSxRow = makeShortcode("PropsTableSxRow");
const ComponentChecklist = makeShortcode("ComponentChecklist");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {PageLayout} from '@primer/react'
`}</code></pre>
    <h2>{`Examples`}</h2>
    <Note mdxType="Note">
      <p>{`See `}<a parentName="p" {...{
          "href": "https://primer.style/react/storybook?path=/story/layout-pagelayout--playground"
        }}>{`storybook`}</a>{` for fullscreen examples.`}</p>
    </Note>
    <h3>{`Default`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<PageLayout>
  <PageLayout.Header>
    <Placeholder label="Header" height={64} />
  </PageLayout.Header>
  <PageLayout.Content>
    <Placeholder label="Content" height={240} />
  </PageLayout.Content>
  <PageLayout.Pane>
    <Placeholder label="Pane" height={120} />
  </PageLayout.Pane>
  <PageLayout.Footer>
    <Placeholder label="Footer" height={64} />
  </PageLayout.Footer>
</PageLayout>
`}</code></pre>
    <h3>{`With dividers`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<PageLayout>
  <PageLayout.Header divider="line">
    <Placeholder label="Header" height={64} />
  </PageLayout.Header>
  <PageLayout.Content>
    <Placeholder label="Content" height={240} />
  </PageLayout.Content>
  <PageLayout.Pane divider="line">
    <Placeholder label="Pane" height={120} />
  </PageLayout.Pane>
  <PageLayout.Footer divider="line">
    <Placeholder label="Footer" height={64} />
  </PageLayout.Footer>
</PageLayout>
`}</code></pre>
    <h3>{`With pane on left`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<PageLayout>
  <PageLayout.Header>
    <Placeholder label="Header" height={64} />
  </PageLayout.Header>
  <PageLayout.Content>
    <Placeholder label="Content" height={240} />
  </PageLayout.Content>
  <PageLayout.Pane position="start">
    <Placeholder label="Pane" height={120} />
  </PageLayout.Pane>
  <PageLayout.Footer>
    <Placeholder label="Footer" height={64} />
  </PageLayout.Footer>
</PageLayout>
`}</code></pre>
    <h3>{`With condensed spacing`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<PageLayout padding="condensed" rowGap="condensed" columnGap="condensed">
  <PageLayout.Header>
    <Placeholder label="Header" height={64} />
  </PageLayout.Header>
  <PageLayout.Content>
    <Placeholder label="Content" height={240} />
  </PageLayout.Content>
  <PageLayout.Pane>
    <Placeholder label="Pane" height={120} />
  </PageLayout.Pane>
  <PageLayout.Footer>
    <Placeholder label="Footer" height={64} />
  </PageLayout.Footer>
</PageLayout>
`}</code></pre>
    <h3>{`Without header or footer`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<PageLayout>
  <PageLayout.Content>
    <Placeholder label="Content" height={240} />
  </PageLayout.Content>
  <PageLayout.Pane>
    <Placeholder label="Pane" height={120} />
  </PageLayout.Pane>
</PageLayout>
`}</code></pre>
    <h2>{`Props`}</h2>
    <h3>{`PageLayout`}</h3>
    {
      /* TODO: Responsive variants */
    }
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="containerWidth" type={`| 'full'
| 'medium'
| 'large'
| 'xlarge'`} defaultValue="'full'" description="The maximum width of the page container." mdxType="PropsTableRow" />
  <PropsTableRow name="padding" type={`| 'none'
| 'normal'
| 'condensed'`} defaultValue="'normal'" description="The spacing between the outer edges of the page container and the viewport" mdxType="PropsTableRow" />
  <PropsTableRow name="columnGap" type={`| 'none'
| 'normal'
| 'condensed'`} defaultValue="'normal'" mdxType="PropsTableRow" />
  <PropsTableRow name="rowGap" type={`| 'none'
| 'normal'
| 'condensed'`} defaultValue="'normal'" mdxType="PropsTableRow" />
  <PropsTableSxRow mdxType="PropsTableSxRow" />
    </PropsTable>
    <h3>{`PageLayout.Header`}</h3>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="divider" type={`| 'none'
| 'line'`} defaultValue="'none'" mdxType="PropsTableRow" />
  <PropsTableRow name="dividerWhenNarrow" type={`| 'inherit'
| 'none'
| 'line'
| 'filled'`} defaultValue="'inherit'" mdxType="PropsTableRow" />
  <PropsTableSxRow mdxType="PropsTableSxRow" />
    </PropsTable>
    <h3>{`PageLayout.Content`}</h3>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="width" type={`| 'full'
| 'medium'
| 'large'
| 'xlarge'`} defaultValue="'full'" description="The maximum width of the content region." mdxType="PropsTableRow" />
  <PropsTableSxRow mdxType="PropsTableSxRow" />
    </PropsTable>
    <h3>{`PageLayout.Pane`}</h3>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="position" type={`| 'start'
| 'end'`} defaultValue="'start'" mdxType="PropsTableRow" />
  <PropsTableRow name="positionWhenNarrow" type={`| 'inherit'
| 'start'
| 'end'`} defaultValue="'inherit'" mdxType="PropsTableRow" />
  <PropsTableRow name="width" type={`| 'small'
| 'medium'
| 'large'`} defaultValue="'medium'" description="The width of the pane." mdxType="PropsTableRow" />
  <PropsTableRow name="divider" type={`| 'none'
| 'line'`} defaultValue="'none'" mdxType="PropsTableRow" />
  <PropsTableRow name="dividerWhenNarrow" type={`| 'inherit'
| 'none'
| 'line'
| 'filled'`} defaultValue="'inherit'" mdxType="PropsTableRow" />
  <PropsTableSxRow mdxType="PropsTableSxRow" />
    </PropsTable>
    <h3>{`PageLayout.Footer`}</h3>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="divider" type={`| 'none'
| 'line'`} defaultValue="'none'" mdxType="PropsTableRow" />
  <PropsTableRow name="dividerWhenNarrow" type={`| 'inherit'
| 'none'
| 'line'
| 'filled'`} defaultValue="'inherit'" mdxType="PropsTableRow" />
  <PropsTableSxRow mdxType="PropsTableSxRow" />
    </PropsTable>
    <h2>{`Status`}</h2>
    <ComponentChecklist items={{
      propsDocumented: true,
      noUnnecessaryDeps: true,
      adaptsToThemes: true,
      adaptsToScreenSizes: true,
      fullTestCoverage: true,
      usedInProduction: true,
      usageExamplesDocumented: true,
      hasStorybookStories: true,
      designReviewed: false,
      a11yReviewed: true,
      stableApi: false,
      addressedApiFeedback: false,
      hasDesignGuidelines: false,
      hasFigmaComponent: false
    }} mdxType="ComponentChecklist" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      